import { TOUR_END } from '../actions/tours.actions';

const toursReducer = (state = {}, { type, payload }) => {
    switch (type) {
        case TOUR_END:
            return { ...state, ...payload };
        default:
            return state;
    }
};

export default toursReducer;
